// src/components/user/PersonalInfoForm.tsx

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Form, Input, App } from 'antd';
import DatePickerHybrid from '../../../../components/forms/DatePickerHybrid';

const PersonalInfoForm: React.FC = () => {
    const { t } = useTranslation();
    const { message } = App.useApp();

    // Filter out Arabic characters (Unicode range \u0600-\u06FF)
    const filterArabicCharacters = (value: string): string => {
        return value.replace(/[\u0600-\u06FF]/g, '');
    };

    const showArabicError = () => {
        message.warning(t('auth.validation.noArabicCharacters'));
    };

    return (
        <Card title={t('text.personal_info')} style={{ marginBottom: 0 }}>
            <Form.Item
                label={t('text.firstname')}
                name={['personal_info', 'firstname']}
                rules={[
                    { required: true, min: 2, message: t('message.value_required') + "-" + t('message.min_len', { len: 2 }) },
                    {
                        validator: (_, value) => {
                            if (value && /[\u0600-\u06FF]/.test(value)) {
                                return Promise.reject(new Error(t('auth.validation.noArabicCharacters')));
                            }
                            return Promise.resolve();
                        },
                    },
                ]}
                getValueFromEvent={(e) => {
                    const filtered = filterArabicCharacters(e.target.value);
                    if (filtered !== e.target.value) {
                        showArabicError();
                    }
                    return filtered;
                }}
                normalize={(value) => filterArabicCharacters(value || '')}
            >
                <Input placeholder="ex : Youssef" />
            </Form.Item>

            <Form.Item
                label={t('text.lastname')}
                name={['personal_info', 'lastname']}
                rules={[
                    { required: true, min: 2, message: t('message.value_required') + "-" + t('message.min_len', { len: 2 }) },
                    {
                        validator: (_, value) => {
                            if (value && /[\u0600-\u06FF]/.test(value)) {
                                return Promise.reject(new Error(t('auth.validation.noArabicCharacters')));
                            }
                            return Promise.resolve();
                        },
                    },
                ]}
                getValueFromEvent={(e) => {
                    const filtered = filterArabicCharacters(e.target.value);
                    if (filtered !== e.target.value) {
                        showArabicError();
                    }
                    return filtered;
                }}
                normalize={(value) => filterArabicCharacters(value || '')}
            >
                <Input placeholder="ex : Benali" />
            </Form.Item>

            <Form.Item
                name={['personal_info', 'birthdate']}
                rules={[
                    { required: true, message: t('message.value_required') },
                    {
                        validator: (_, value) => {
                            if (value && typeof value === 'string') return Promise.resolve();
                            if (!value) return Promise.reject(new Error(t('message.value_required')));
                            return Promise.resolve();
                        },
                    },
                ]}
                style={{ marginBottom: 24 }}
            >
                <DatePickerHybrid primaryColor="#2D9CC9" />
            </Form.Item>
        </Card>
    );
};

export default PersonalInfoForm;
